// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mg-c";
export var backButton = "_mg-4";
export var backIcon = "_mg-5";
export var chevronShortcut = "_mg-6";
export var container = "_mg-1";
export var editor = "_mg-8";
export var editorWrapper = "_mg-7";
export var prefix = "_mg-2";
export var searchIcon = "_mg-3";
export var suffix = "_mg-9";
export var suffixContent = "_mg-a";
export var suffixText = "_mg-b";
export var wrapper = "_mg-0";